module.exports = __webpack_public_path__ + "media/images/emoticons/phoneto-fc13f1b85c267747e68d18fc85b7f094.gif";